<template>
  <div class="flex w-full text-right justify-end">
    <div class="flex flex-row">
      <div v-for="index in 6" :key="index">
        <div class="relative text-center" :class="[index < 6 ? 'pr-6' : 'pr-0']">
          <div class="absolute inset-0 flex items-center z-0" aria-hidden="true">
            <div class="h-0.5 w-full z-0" :class="[index <= currentStep ? 'bg-brand-primary' : 'bg-black']"/>
          </div>
          <div
            class="relative font-poppins z-20 w-6 h-6 rounded-full"
            :class="[index <=  currentStep ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark text-white' : 'bg-white border-solid border border-black text-black']"
          >
            {{ index }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import { defineProps, defineEmits } from 'vue';

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');

defineProps<{
  currentStep: number
}>();
</script>
